import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CONSULTANT_PHONE } from '../../constants/consultantPhone';
import { IConsultantContactsState } from '../../types/consultantContacts/consultantContacts';

const initialState: IConsultantContactsState = {
  phone: CONSULTANT_PHONE,
  isContactsModalOpen: false,
};

export const consultantContactsSlice = createSlice({
  name: 'consultantContacts',
  initialState,
  reducers: {
    setIsContactsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isContactsModalOpen = action.payload;
    },
  },
});

export const {
  reducer: consultantContactsReducer,
  actions: { setIsContactsModalOpen },
} = consultantContactsSlice;
